(function($, Drupal) {
  'use strict';

  Drupal.behaviors.issue_numbers = {
    attach: function(context, settings) {
      let $issue_toggles = $('.js-toggle-issues', context);

      if ($issue_toggles.length !== 0) {
        $issue_toggles.once('toggles-add').on('click', function() {
          $(this).toggleClass('expanded');
          $(this).siblings('ul').slideToggle(300);
        });
      }

      let $season_toggles = $('.js-toggle-seasons', context);

      // Toggle for volumes sidebar
      if ($season_toggles.length !== 0) {
        $season_toggles.once('season-toggles-add').on('click', function() {
          $(this).toggleClass('expanded');
          $(this).siblings('div').slideToggle(300);
        });
      }
    }
  };
})(jQuery, Drupal);
